import { useEffect, useRef, useState } from 'react';
import { SuggestedItem, PostData } from '../types';
import api from '@/utils/api';

export const usePostData = (item: SuggestedItem | null, isOpen: boolean) => {
  const [postData, setPostData] = useState<PostData>({
    title: '',
    subtitle: '',
    mainText: '',
    logo: '',
    photo: '',
    background: '',
    image1: '',
    image2: '',
    color1: '',
    color2: '',
    color3: '',
    contentType: '',
    imageGeneratedTopic: '',
    bullets: [],
    date: '',
    time: '',
    speakerPhoto: '',
    speakerRole: '',
    phone: '',
    website: '',
    backgroundColor: '',
    brandHandle: '',
    brandName: '',
    plannedDate: null,
    postStatus: 'draft',
    document: '',
    fontForText: '',
    cta: '',
    templateName: '',
  });

  const originalPlannedDateRef = useRef<string | null>(null);
  const savedTemplateNameRef = useRef<string | null>(null);

  useEffect(() => {
    if (isOpen && item) {
      const fetchPostData = async () => {
        try {
          const response = await api.get(`/mxm/posts/${item.id}`);
          const data = response.data;

          if (data) {
            setPostData({
              title: data.title || item.title || '',
              subtitle: data.subtitle || item.subtitle || '',
              mainText: data.mainText || '',
              logo: data.logo || item.logo || '',
              photo: data.photo || item.photo || '',
              background: data.background || '',
              image1: data.image1 || '',
              image2: data.image2 || '',
              color1: data.color1 || item.color1 || '#e92d4b',
              color2: data.color2 || item.color2 || '#ffffff',
              color3: data.color3 || item.color3 || '#000000',
              contentType: data.contentType || item.template || '',
              imageGeneratedTopic: data.imageGeneratedTopic || '',
              bullets: data.bullets || [],
              date: data.date || '',
              time: data.time || '',
              speakerPhoto: data.speakerPhoto || '',
              speakerRole: data.speakerRole || '',
              phone: data.phone || '',
              website: data.website || '',
              backgroundColor: data.backgroundColor || '',
              brandHandle: data.brandHandle || '',
              brandName: data.brandName || '',
              plannedDate: item.plannedDate ? new Date(item.plannedDate) : null,
              postStatus: data.postStatus || 'draft',
              document: data.document || '',
              fontForText: data.fontForText || '',
              cta: data.cta || item.cta || '',
              templateName: data.templateName || '',
            });
            originalPlannedDateRef.current = item.plannedDate ? (typeof item.plannedDate === 'string' ? item.plannedDate : item.plannedDate.toISOString()) : null;
            savedTemplateNameRef.current = data.templateName || null;
          }
        } catch (error: unknown) {
          console.error('Failed to fetch post data:', error);
          // Fallback to item data if API fails
          setPostData(prev => ({
            ...prev,
            title: item.title || '',
            subtitle: item.subtitle || '',
            logo: item.logo || '',
            photo: item.photo || '',
            color1: item.color1 || '#e92d4b',
            color2: item.color2 || '#ffffff',
            color3: item.color3 || '#000000',
            contentType: item.template || '',
            plannedDate: item.plannedDate ? new Date(item.plannedDate) : null,
            cta: item.cta || '',
            templateName: '',
          }));
        }
      };

      fetchPostData();
    }
  }, [isOpen, item]);

  const updatePostData = (updates: Partial<PostData>) => {
    setPostData(prev => ({ ...prev, ...updates }));
  };

  return {
    postData,
    updatePostData,
    originalPlannedDateRef,
    savedTemplateNameRef
  };
};
